export enum CustomerType {
  msisdn = "MSISDN",
  broadband = "BROADBAND",
  can = "CAN",
  uan = "UAN",
  tv = "TV",
}
